export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-16 md:pt-20 overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20manga%20illustration%20with%20soft%20coral%20and%20cream%20gradient%20background%2C%20delicate%20ink%20wash%20style%20texture%2C%20floating%20comic%20panel%20lines%20in%20subtle%20warm%20tones%2C%20elegant%20minimal%20composition%2C%20dreamy%20atmosphere%2C%20no%20text%2C%20no%20characters%2C%20pure%20aesthetic%20design%20with%20gentle%20color%20transitions&width=1600&height=900&seq=hero-bg-manga-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/30 to-background-50/95"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-16 py-12 md:py-20">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-sm font-medium mb-4 whitespace-nowrap">
              韩漫 · 日漫 · 国漫 大全集
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading text-foreground-900 leading-tight mb-4">
              羞羞漫画
              <span className="block text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-primary-500 mt-2">
                海量漫画免费追更平台
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-3 max-w-xl mx-auto lg:mx-0">
              羞羞漫画汇聚韩漫、日漫、国漫等海量正版漫画资源，支持下拉式在线阅读与实时追更。每日更新热门推荐，全网最全免费全集一网打尽，随时随地畅享阅读乐趣。
            </p>
            <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              当前热更专题涵盖都市恋爱、奇幻冒险、悬疑推理等多题材方向，新作首发不断，追更不迷路。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-book-open-line text-primary-500 text-lg"></i>
                </div>
                <span className="text-sm text-foreground-600 whitespace-nowrap">日更 <strong className="text-primary-500">200+</strong> 话</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-group-line text-accent-500 text-lg"></i>
                </div>
                <span className="text-sm text-foreground-600 whitespace-nowrap">覆盖 <strong className="text-accent-500">3000+</strong> 部作品</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-secondary-500 text-lg"></i>
                </div>
                <span className="text-sm text-foreground-600 whitespace-nowrap">全本免费无广告</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-fire-line text-lg"></i>
                热门排行
              </a>
              <a
                href="#cards"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 rounded-full border-2 border-foreground-200 text-foreground-700 font-semibold text-base hover:border-primary-400 hover:text-primary-500 transition-all duration-200 whitespace-nowrap cursor-pointer"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                <i className="ri-compass-3-line text-lg"></i>
                精选推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[280px] sm:w-[360px] sm:h-[360px] md:w-[440px] md:h-[440px] lg:w-[500px] lg:h-[500px]">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20manga%20reading%20illustration%20on%20mobile%20phone%20screen%20with%20colorful%20comic%20panels%20floating%20around%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20modern%20flat%20design%20style%2C%20youthful%20and%20energetic%20atmosphere%2C%20reading%20app%20interface%20mockup%20with%20manga%20pages%2C%20soft%20gradient%20background%2C%20clean%20composition%2C%20no%20text&width=500&height=500&seq=hero-main-visual-01&orientation=squarish"
                alt="羞羞漫画在线阅读界面 - 韩漫日漫国漫免费追更"
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}